import find from 'lodash/find';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import AnimationUtils from '@spothero/utils/animation';
import DOMUtils from '@spothero/utils/dom';
import {toggleListView} from '../search-actions';
import SpotList from './SpotList';
import SpotListFeatureDesktop from './SpotListFeatureDesktop';
import SpotListFilters from './SpotListFilters';

class SpotListContainerDesktop extends Component {
    static propTypes = {
        spots: PropTypes.arrayOf(PropTypes.object).isRequired,
        selectedSpot: PropTypes.object,
        isListVisible: PropTypes.bool.isRequired,
        isEvent: PropTypes.bool.isRequired,
        toggleSpotList: PropTypes.func.isRequired,
        searchRequestId: PropTypes.string.isRequired,
        isMonthly: PropTypes.bool.isRequired
    };
    static defaultProps = {
        isListVisible: true
    };

    componentDidMount() {
        this._activeSpot = find(this.props.spots, 'activeMarker');
        this._adjustForSpotListFeatureHeight();
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            searchRequestId: prevSearchRequestId,
            selectedSpot: prevSelectedSpot,
            isMonthly: prevIsMonthly
        } = prevProps;
        const {
            spots,
            selectedSpot,
            isListVisible,
            toggleSpotList,
            searchRequestId,
            isMonthly
        } = this.props;
        const newActiveSpot = find(spots, 'activeMarker');
        const bodyWidth = DOMUtils.width('body');

        if (newActiveSpot && (!this._activeSpot || this._activeSpot.spotId !== newActiveSpot.spotId)) {
            // if a new active spot is set, scroll the list to its position
            const item = DOMUtils.el(`.result${newActiveSpot.spotId}`);

            if (item) {
                AnimationUtils.scrollTo(this._list, item.offsetTop, 250, 'y', () => {
                    DOMUtils.removeClass(item, 'highlight'); // remove it first in case it existed

                    // a short delay ensures the css animation repeats
                    setTimeout(() => {
                        DOMUtils.addClass(item, 'highlight');
                    }, 150);
                });
            }
        }

        this._activeSpot = newActiveSpot;

        if ((!prevSelectedSpot && selectedSpot && bodyWidth < 1020 && isListVisible) ||
            (prevSelectedSpot && !selectedSpot && bodyWidth < 1020)) {
            toggleSpotList();
        }

        if (prevSearchRequestId !== searchRequestId || prevIsMonthly !== isMonthly) {
            this._adjustForSpotListFeatureHeight();
        }
    }

    _adjustForSpotListFeatureHeight = () => {
        this._list.style.top = `${DOMUtils.height('.SpotListFeature .detail')}px`;
    }

    render() {
        const {
            spots,
            isEvent
        } = this.props;

        return (
            <div
                className="SpotListContainer"
                itemScope={(isEvent) ? true : null}
                itemType={(isEvent) ? 'http://schema.org/Event' : null}
            >
                <div className="list">
                    <SpotListFeatureDesktop
                        spots={spots}
                    />
                    <div
                        className="list-scroll"
                        ref={node => { this._list = node; }}
                    >
                        <SpotList
                            spots={spots}
                        />
                    </div>
                </div>
                <SpotListFilters />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        search: {
            data: {
                searchType,
                selectedSpot,
                isListVisible
            }
        },
        searchRequest: {
            id,
            monthly: isMonthly
        }
    } = state;

    return {
        isEvent: (searchType === 'event'),
        selectedSpot,
        isListVisible,
        searchRequestId: id,
        isMonthly
    };
};

const mapDispatchToProps = {
    toggleSpotList: toggleListView
};

export default connect(mapStateToProps, mapDispatchToProps)(SpotListContainerDesktop);
